import { render, staticRenderFns } from "./teacherIntroduce.vue?vue&type=template&id=4100a1ff&scoped=true"
import script from "./teacherIntroduce.vue?vue&type=script&lang=js"
export * from "./teacherIntroduce.vue?vue&type=script&lang=js"
import style0 from "./teacherIntroduce.vue?vue&type=style&index=0&id=4100a1ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4100a1ff",
  null
  
)

export default component.exports